import cl from "clsx";
import React from "react";
import { CheckmarkIcon } from "@navikt/aksel-icons";
import { BodyShort } from "../../../typography/index.js";
import { useInputContext } from "../Input/Input.context.js";
import { useSelectedOptionsContext } from "../SelectedOptions/selectedOptionsContext.js";
import { isInList } from "../combobox-utils.js";
import filteredOptionsUtil from "./filtered-options-util.js";
import { useFilteredOptionsContext } from "./filteredOptionsContext.js";
const FilteredOptionsItem = ({ option }) => {
    const { inputProps: { id }, size, } = useInputContext();
    const { setIsMouseLastUsedInputDevice, toggleIsListOpen, activeDecendantId, virtualFocus, } = useFilteredOptionsContext();
    const { isMultiSelect, maxSelected, selectedOptions, toggleOption } = useSelectedOptionsContext();
    const isDisabled = (_option) => (maxSelected === null || maxSelected === void 0 ? void 0 : maxSelected.isLimitReached) && !isInList(_option.value, selectedOptions);
    return (React.createElement("li", { className: cl("navds-combobox__list-item", {
            "navds-combobox__list-item--focus": activeDecendantId ===
                filteredOptionsUtil.getOptionId(id, option.label),
            "navds-combobox__list-item--selected": isInList(option.value, selectedOptions),
        }), "data-no-focus": isDisabled(option) || undefined, id: filteredOptionsUtil.getOptionId(id, option.label), key: option.label, tabIndex: -1, onMouseMove: () => {
            if (activeDecendantId !==
                filteredOptionsUtil.getOptionId(id, option.label)) {
                virtualFocus.moveFocusToElement(filteredOptionsUtil.getOptionId(id, option.label));
                setIsMouseLastUsedInputDevice(true);
            }
        }, onPointerUp: (event) => {
            if (isDisabled(option)) {
                return;
            }
            toggleOption(option, event);
            if (!isMultiSelect && !isInList(option.value, selectedOptions)) {
                toggleIsListOpen(false);
            }
        }, role: "option", "aria-selected": isInList(option.value, selectedOptions), "aria-disabled": isDisabled(option) || undefined },
        React.createElement(BodyShort, { size: size }, option.label),
        isInList(option.value, selectedOptions) && React.createElement(CheckmarkIcon, null)));
};
export default FilteredOptionsItem;
//# sourceMappingURL=FilteredOptionsItem.js.map